// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.visitor-info-container {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
  font-family: Arial, sans-serif;
}

.visitor-header h1 {
  font-size: 1.8rem;
  margin-bottom: 5px;
}
.visitor-header p {
  color: #555;
  margin-bottom: 20px;
}

.visitor-stats-grid {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  margin-bottom: 30px;
}

.visitor-card {
  background: #fff;
  border-radius: 12px;
  flex: 1 1 250px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.1);
}

.card-content span:first-child {
  display: block;
  color: #666;
  margin-bottom: 5px;
}
.card-value {
  font-size: 1.5rem;
  font-weight: bold;
}

.status-green { color: green; }
.status-purple { color: purple; }

.card-icon {
  font-size: 2rem;
}

.visitor-table-section {
  margin-bottom: 30px;
}

.visitor-table-section h2 {
  margin-bottom: 10px;
  font-size: 1.3rem;
}

.table-wrapper {
  overflow-x: auto;
}

.visitor-table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
}

.visitor-table th, .visitor-table td {
  padding: 10px 12px;
  text-align: left;
  border-bottom: 1px solid #eee;
}

.visitor-table th {
  background: #f3f4f6;
  font-weight: 600;
}

.status-pill {
  padding: 3px 8px;
  border-radius: 12px;
  font-size: 0.85rem;
  color: #fff;
  display: inline-block;
}

.status-pill.active { background-color: #22c55e; }
.status-pill.stable { background-color: #6366f1; }

.no-data {
  text-align: center;
  color: #888;
  padding: 15px 0;
}

.refresh-btn {
  background: #3b82f6;
  color: #fff;
  border: none;
  padding: 6px 12px;
  border-radius: 6px;
  cursor: pointer;
}

.refresh-btn:hover { background: #2563eb; }

.visitor-loader, .visitor-error {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 300px;
  font-size: 1rem;
  color: #555;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #d1d5db;
  border-top: 4px solid #3b82f6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 10px;
}

@keyframes spin {
  0% { transform: rotate(0deg);}
  100% { transform: rotate(360deg);}
}

/* Responsive */
@media (max-width: 768px) {
  .visitor-stats-grid {
    flex-direction: column;
  }
  .visitor-card {
    flex: 1 1 100%;
  }
  .visitor-table th, .visitor-table td {
    padding: 8px 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/InfoManage/VisitorInfo.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,gBAAgB,YAAY,EAAE;AAC9B,iBAAiB,aAAa,EAAE;;AAEhC;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,qBAAqB;AACvB;;AAEA,sBAAsB,yBAAyB,EAAE;AACjD,sBAAsB,yBAAyB,EAAE;;AAEjD;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,qBAAqB,mBAAmB,EAAE;;AAE1C;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,CAAC;EAC7B,OAAO,yBAAyB,CAAC;AACnC;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;EACxB;EACA;IACE,cAAc;EAChB;EACA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".visitor-info-container {\n  padding: 20px;\n  max-width: 1200px;\n  margin: 0 auto;\n  font-family: Arial, sans-serif;\n}\n\n.visitor-header h1 {\n  font-size: 1.8rem;\n  margin-bottom: 5px;\n}\n.visitor-header p {\n  color: #555;\n  margin-bottom: 20px;\n}\n\n.visitor-stats-grid {\n  display: flex;\n  gap: 20px;\n  flex-wrap: wrap;\n  margin-bottom: 30px;\n}\n\n.visitor-card {\n  background: #fff;\n  border-radius: 12px;\n  flex: 1 1 250px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px 20px;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.1);\n}\n\n.card-content span:first-child {\n  display: block;\n  color: #666;\n  margin-bottom: 5px;\n}\n.card-value {\n  font-size: 1.5rem;\n  font-weight: bold;\n}\n\n.status-green { color: green; }\n.status-purple { color: purple; }\n\n.card-icon {\n  font-size: 2rem;\n}\n\n.visitor-table-section {\n  margin-bottom: 30px;\n}\n\n.visitor-table-section h2 {\n  margin-bottom: 10px;\n  font-size: 1.3rem;\n}\n\n.table-wrapper {\n  overflow-x: auto;\n}\n\n.visitor-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: #fff;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.visitor-table th, .visitor-table td {\n  padding: 10px 12px;\n  text-align: left;\n  border-bottom: 1px solid #eee;\n}\n\n.visitor-table th {\n  background: #f3f4f6;\n  font-weight: 600;\n}\n\n.status-pill {\n  padding: 3px 8px;\n  border-radius: 12px;\n  font-size: 0.85rem;\n  color: #fff;\n  display: inline-block;\n}\n\n.status-pill.active { background-color: #22c55e; }\n.status-pill.stable { background-color: #6366f1; }\n\n.no-data {\n  text-align: center;\n  color: #888;\n  padding: 15px 0;\n}\n\n.refresh-btn {\n  background: #3b82f6;\n  color: #fff;\n  border: none;\n  padding: 6px 12px;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.refresh-btn:hover { background: #2563eb; }\n\n.visitor-loader, .visitor-error {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 300px;\n  font-size: 1rem;\n  color: #555;\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #d1d5db;\n  border-top: 4px solid #3b82f6;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 10px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg);}\n  100% { transform: rotate(360deg);}\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .visitor-stats-grid {\n    flex-direction: column;\n  }\n  .visitor-card {\n    flex: 1 1 100%;\n  }\n  .visitor-table th, .visitor-table td {\n    padding: 8px 10px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
